import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { HomeworkShell, useHwAccount } from "./HomeworkShell";
import { hwApi, hwErr, HW_CATEGORIES, fmtDate } from "./hwApi";

function ProfileInner() {
  const account = useHwAccount();
  const [form, setForm] = useState({ name: account.name, category: account.category, mobile: account.mobile || "", parent_email: account.parent_email || "" });
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      await hwApi.patch("/profile", form);
      setSaved(true);
    } catch (err) { setError(hwErr(err)); } finally { setSaving(false); }
  };

  return (
    <div className="tp-wrap" style={{ maxWidth: 620 }} data-testid="hw-profile">
      <div className="tp-eyebrow">MY PROFILE</div>
      <h1 className="tp-h2" style={{ fontSize: 30 }}>{account.name}</h1>
      <div className="tp-panel" style={{ marginTop: 16 }}>
        <div className="tp-detail-grid" data-testid="hw-profile-info">
          <div>STUDENT ID<b data-testid="hw-profile-id">{account.student_id}</b></div>
          <div>EMAIL<b>{account.email}{account.email_verified ? " ✓" : ""}</b></div>
          <div>CATEGORY<b>{HW_CATEGORIES.find((c) => c.key === account.category)?.label || account.category}</b></div>
          <div>MEMBER SINCE<b>{fmtDate(account.created_at)}</b></div>
        </div>
      </div>
      <div className="tp-panel" style={{ marginTop: 16 }}>
        <h2 className="tp-h2" style={{ fontSize: 20 }}>Edit profile</h2>
        {error && <p className="tp-error" role="alert" data-testid="hw-profile-error">{error}</p>}
        {saved && <p className="tp-pill ok" data-testid="hw-profile-saved"><Check size={14} /> Profile saved</p>}
        <form onSubmit={save} data-testid="hw-profile-form">
          <label className="tp-label">FULL NAME<input required value={form.name} onChange={(e) => { setForm((c) => ({ ...c, name: e.target.value })); setSaved(false); }} data-testid="hw-edit-name" /></label>
          <label className="tp-label">CLASS / EXAM
            <select value={form.category} onChange={(e) => { setForm((c) => ({ ...c, category: e.target.value })); setSaved(false); }} data-testid="hw-edit-category">
              {HW_CATEGORIES.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
            </select>
          </label>
          <label className="tp-label">MOBILE (OPTIONAL)<input value={form.mobile} onChange={(e) => { setForm((c) => ({ ...c, mobile: e.target.value })); setSaved(false); }} placeholder="10-digit number" inputMode="numeric" data-testid="hw-edit-mobile" /></label>
          <label className="tp-label">PARENT'S EMAIL (OPTIONAL — weekly progress report)<input type="email" value={form.parent_email} onChange={(e) => { setForm((c) => ({ ...c, parent_email: e.target.value })); setSaved(false); }} placeholder="parent@example.com" data-testid="hw-edit-parent-email" /></label>
          <p className="tp-note">Changing your class/exam changes the syllabus and topics you see.</p>
          <button className="tp-btn" style={{ width: "100%" }} disabled={saving} type="submit" data-testid="hw-profile-save">{saving ? "Saving…" : "SAVE PROFILE"}</button>
        </form>
      </div>
    </div>
  );
}

export default function HomeworkProfile() {
  return <HomeworkShell><ProfileInner /></HomeworkShell>;
}
